import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthContext } from "./AuthContext";

function RouteGuard() {
  const { user, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return <></>;
  }

  // Remember where a signed-out user was going -- a link out of the dealer email, say -- so
  // sign-in can send them there rather than to the default landing page (utils/deepLink.js).
  if (!user) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

export default RouteGuard;
